import DataGrid2 from '../..';
import { IOnLoadArgs } from '../../../../../../entities/common';
import { createArrayStore, createCustomStore, createSelfCustomStore } from '../customStore';

export async function bindCustomStore(this: DataGrid2, args: IOnLoadArgs) {
	if (this.saveMode === 'self') {
		if (this.__store) {
			await this.__bcDataGridRef.current?.instance().refresh();
		} else {
			this.__store = createSelfCustomStore(this);
		}
	} else if (this.dataSource.name && !this.dataSource.runAtServer) {
		this.__onLoadArgs = args;

		if (this.__store) {
			await this.__bcDataGridRef.current?.instance().refresh();
		} else {
			this.__store = createCustomStore(this);
		}
	}
}

export async function bindArrayStore(this: DataGrid2) {
	if (this.saveMode === 'self' || (this.dataSource.name && !this.dataSource.runAtServer)) {
		return;
	}

	this.__store = createArrayStore.call(this);
}
